// models/pedidos/TaxaEntrega.js
export class TaxaEntrega {
    constructor(
        id = 0,
        valor = 0,
        limiteKm = 0,
        valorDefault = false,
    ) {
        this.id = id;                            // int
        this.valor = valor;    // int? (nullable)
        this.limiteKm = limiteKm;        // int? (nullable)
        this.valorDefault = valorDefault; // bool
    }
}
